import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

export interface AreaPolygons {
  area_polygons: {
    features: object[];
    type: string;
  };
}

const useIndexPolygon = (polygonId?: number | null) => {
  return useQuery({
    queryKey: ['polygon', polygonId],
    queryFn: async (): Promise<AreaPolygons | null> => {
      if (!polygonId || polygonId === undefined) return null;
      const URL = `${import.meta.env.VITE_API_INDEX_POLYGON_URL}?id=${polygonId}`;

      const { data } = await axiosClient.get(URL);

      return data.area_polygons;
    },
  });
};

export default useIndexPolygon;
